var React = require('react');

function Facebook (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M18.9999 0.833252H4.99992C2.42259 0.833252 0.333252 2.92259 0.333252 5.49992V19.4999C0.333252 22.0772 2.42259 24.1666 4.99992 24.1666H10.2499V17.1666H6.16659V13.6666H10.2499V10.6666C10.2499 8.45745 12.0408 6.66659 14.2499 6.66659H17.8333V10.1666H14.7499C14.1976 10.1666 13.7499 10.6143 13.7499 11.1666V13.6666H17.8333V17.1666H13.7499V24.1666H18.9999C21.5772 24.1666 23.6666 22.0772 23.6666 19.4999V5.49992C23.6666 2.92259 21.5772 0.833252 18.9999 0.833252Z","fill":"white"}));
}

Facebook.defaultProps = {"width":"24","height":"25","viewBox":"0 0 24 25","fill":"none"};

module.exports = Facebook;

Facebook.default = Facebook;
